import { 
  ShoppingCart, 
  Package, 
  TrendUp, 
  Warning
} from "@phosphor-icons/react";
import { Card, CardContent } from "@/components/ui/card";

export default function StatsCards({ summary }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card className="stat-card" data-testid="stat-total-spent">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="data-label">Total Gastado</p>
              <p className="text-3xl font-bold text-slate-900 mt-1">{summary.total_gastado.toFixed(2)}€</p>
            </div>
            <div className="p-3 bg-blue-100 rounded-full">
              <TrendUp size={24} className="text-blue-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="stat-card" data-testid="stat-total-purchases">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="data-label">Total Compras</p>
              <p className="text-3xl font-bold text-slate-900 mt-1">{summary.total_compras}</p>
            </div>
            <div className="p-3 bg-green-100 rounded-full">
              <ShoppingCart size={24} className="text-green-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="stat-card" data-testid="stat-low-stock">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="data-label">Bajo Stock</p>
              <p className="text-3xl font-bold text-slate-900 mt-1">{summary.articulos_bajo_stock}</p>
            </div>
            <div className="p-3 bg-yellow-100 rounded-full">
              <Warning size={24} className="text-yellow-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="stat-card" data-testid="stat-unique-items">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="data-label">Artículos Únicos</p>
              <p className="text-3xl font-bold text-slate-900 mt-1">{summary.articulos_unicos}</p>
            </div>
            <div className="p-3 bg-purple-100 rounded-full">
              <Package size={24} className="text-purple-600" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
